<template>
  <div class="home-container">
    <article ref="info">
      <div class="date-weather">今天是 {{ getDate() }} {{ weather }}</div>
      <div class="user">你好，<span>{{ userInfo.name }} ！</span></div>
      <div class="greeting">欢迎来到智慧校园平台。</div>
      <div class="search">
        <input type="text" placeholder="输入应用名称以搜索" v-model="keyword" @keyup.enter="search" />
        <button><i class="el-icon-search"></i></button>
      </div>
      <div class="warning" ref="tip">
        <i class="el-icon-warning"></i>
        <span>暂无您要搜索的应用，请检查拼写后重新搜索...</span>
      </div>
      <div class="result">
        <div class="item" v-for="item in findAppList" @click="clickApp(item.sourceType, item.id, item.url)">
          <span>{{ item.name }}</span>
          <i class="el-icon-right"></i>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Home',
  props: ['pageIndex', 'appList', 'clickApp'],
  data() {
    return {
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      weather: '',
      keyword: '',
      findAppList: []
    }
  },
  watch: {
    pageIndex(val) {
      this.$refs.info.style.transform = val === 0 ? 'translateY(0)' : 'translateY(150%)'
      this.$refs.info.style.opacity = val === 0 ? 1 : 0
    },
    keyword(val) {
      if (val) {
        this.findAppList = []
        this.appList.forEach(item => {
          item.children.forEach(_item => {
            if (_item.name.indexOf(this.keyword) !== -1) {
              this.findAppList.push(_item)
            }
          })
        })
        this.$refs.tip.style.opacity = this.findAppList.length ? 0 : 1
      } else {
        this.findAppList = []
        this.$refs.tip.style.opacity = 0
      }
    }
  },
  created() {
    this.getWeather()
  },
  methods: {
    getDate() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let week = date.getDay()
      return `${year}年${month}月${day}日 / 星期${['日', '一', '二', '三', '四', '五', '六'][week]}`
    },
    async getWeather() {
      navigator.geolocation.getCurrentPosition((res) => {
        const { latitude, longitude } = res.coords
        axios.get('https://restapi.amap.com/v3/geocode/regeo', {
          params: {
            key: '5b726dec8ffbfde8bb952750b1eb0ae3',
            location: longitude + ',' + latitude,
          }
        }).then(res => {
          axios.get('https://restapi.amap.com/v3/weather/weatherInfo', {
            params: {
              key: '5b726dec8ffbfde8bb952750b1eb0ae3',
              city: res.data.regeocode.addressComponent.adcode,
            }
          }).then(res => {
            const { city, weather, temperature } = res.data.lives[0]
            this.weather = `${city} · ${weather} · ${temperature}°C`
          })
        })
      }, () => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  height: 100%;
  background: no-repeat center/cover url(../../assets/home.png), #fff;
  overflow: hidden;

  article {
    width: fit-content;
    padding-top: 20vh;
    padding-left: 20vh;
    transition: 700ms;

    .date-weather {
      font-size: calc(16*var(--ratio));
      color: $homeRed;
    }

    .user {
      font-size: calc(50*var(--ratio));
      color: #2e2e2e;
      margin: calc(60*var(--ratio)) 0 calc(30*var(--ratio));
    }

    .greeting {
      font-size: calc(60*var(--ratio));
      font-weight: bold;
      color: transparent;
      -webkit-text-stroke: 1px #333;
      background: linear-gradient(to right, #333 50%, transparent 50%);
      background-size: 200% 100%;
      background-position: 100%;
      background-clip: text;
      animation: fontColor 10s infinite;
    }

    @keyframes fontColor {
      50% {
        background-position: 0%;
        -webkit-text-stroke: 1px transparent;
      }

      100% {
        background-position: -100%;
      }
    }

    .search {
      display: flex;
      width: fit-content;
      margin: calc(50*var(--ratio)) 0 calc(20*var(--ratio));

      input {
        height: calc(40*var(--ratio));
        width: calc(300*var(--ratio));
        padding: 0 calc(15*var(--ratio));
        border: 1px solid $homeRed;
        outline: none;
        color: $homeRed;
        font-size: calc(15*var(--ratio));

        &:focus {
          border: calc(2*var(--ratio)) solid $homeRed !important;
          font-weight: bold;
        }

        &::placeholder {
          color: #bbb;
          font-size: calc(15*var(--ratio));
        }
      }

      button {
        width: calc(60*var(--ratio));
        height: calc(40*var(--ratio));
        background: $homeRed;
        color: #fff;
        cursor: pointer;
        outline: none;
        border: 1px solid $homeRed;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: calc(16*var(--ratio));
          transition: 300ms;
        }

        &:hover i {
          scale: 1.2;
        }
      }
    }

    .warning {
      width: fit-content;
      color: $homeRed;
      font-size: calc(14*var(--ratio));
      font-weight: bold;
      opacity: 0;

      span {
        margin-left: calc(6*var(--ratio));
      }
    }

    .result {
      color: $homeRed;
      font-weight: bold;
      overflow: hidden;
      width: fit-content;

      .item {
        font-size: calc(16*var(--ratio));
        cursor: pointer;
        transition: 300ms;

        &:hover {
          font-size: calc(26*var(--ratio));
          background: $homeRed;
          color: #fff;
          padding: calc(6*var(--ratio)) calc(12*var(--ratio));

          i {
            opacity: 1;
          }
        }

        i {
          opacity: 0;
          margin-left: calc(6*var(--ratio));
        }
      }

      .item+.item {
        margin-top: calc(20*var(--ratio));
      }
    }
  }
}
</style>